module.exports = __webpack_public_path__ + "assets/img/5_1375.ac67fecc.jpg";